var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllowed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M26 0H10C4.47715 0 0 4.47715 0 10V25C0 30.5228 4.47715 35 10 35H26C31.5228 35 36 30.5228 36 25V10C36 4.47715 31.5228 0 26 0Z",
    fill: "#D3FF9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4191 14.2771L16.0681 19.6291L13.6161 17.1771C13.5282 17.0892 13.4239 17.0195 13.3092 16.972C13.1944 16.9245 13.0713 16.9 12.9471 16.9C12.8228 16.9 12.6998 16.9245 12.585 16.972C12.4702 17.0195 12.3659 17.0892 12.2781 17.1771C12.1902 17.2649 12.1205 17.3692 12.073 17.484C12.0255 17.5988 12.001 17.7218 12.001 17.8461C12.001 17.9703 12.0255 18.0934 12.073 18.2081C12.1205 18.3229 12.1902 18.4272 12.2781 18.5151L15.3991 21.6361C15.4869 21.7239 15.5913 21.7936 15.706 21.8411C15.8208 21.8887 15.9438 21.9131 16.0681 21.9131C16.1923 21.9131 16.3154 21.8887 16.4301 21.8411C16.5449 21.7936 16.6492 21.7239 16.7371 21.6361L22.7571 15.6161C22.9345 15.4387 23.0342 15.198 23.0342 14.9471C23.0342 14.6962 22.9345 14.4555 22.7571 14.2781C22.5797 14.1007 22.339 14.001 22.0881 14.001C21.8372 14.001 21.5965 14.1007 21.4191 14.2781V14.2771Z",
    fill: "#D3FF9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllowed);
export default __webpack_public_path__ + "static/media/allowed.282bd9a360e526ef09382d3993af2ddc.svg";
export { ForwardRef as ReactComponent };